function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import AmbulatoryGlucoseProfile from 'modules/AmbulatoryGlucoseProfile';
import Widget from 'components/Widget';
import TimeInRangesChart from 'components/Charts/TimeInRangesChart';
import GlucoseLevelDistributionChart from 'components/Charts/GlucoseLevelDistributionChart';
import * as constants from '../../constants';
import messages from '../../messages';
import styles from './MixedDistributionWidget.pcss';
var _React_Component;
class MixedDistributionWidget extends (_React_Component = React.Component) {
    render() {
        const { conversion, standards, statistics, isDisplayedTimeInRanges } = this.props;
        if (!isDisplayedTimeInRanges) {
            return /*#__PURE__*/ _jsx(Widget, {
                widgetId: constants.GLUCOSE_LEVEL_DISTRIBUTION_WIDGET,
                headerMessage: messages.headers.glucoseLevelDistribution,
                headerAdditionalMessage: "%(N)",
                children: /*#__PURE__*/ _jsx(GlucoseLevelDistributionChart, _object_spread_props(_object_spread({}, this.props), {
                    valueKey: "value"
                }))
            });
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.mixedDistributionWidget,
            children: [
                /*#__PURE__*/ _jsx(Widget, {
                    widgetId: constants.GLUCOSE_LEVEL_DISTRIBUTION_WIDGET,
                    headerMessage: messages.headers.glucoseLevelDistribution,
                    headerAdditionalMessage: "%(N)",
                    children: /*#__PURE__*/ _jsx(GlucoseLevelDistributionChart, _object_spread_props(_object_spread({}, this.props), {
                        valueKey: "value",
                        verticalLegend: true
                    }))
                }),
                /*#__PURE__*/ _jsx(Widget, {
                    widgetId: constants.GLUCOSE_LEVEL_DISTRIBUTION_TIMEINRANGES_WIDGET,
                    headerMessage: messages.headers.cgmTimeInRanges,
                    children: /*#__PURE__*/ _jsx(TimeInRangesChart, {
                        conversion: this.props.conversion,
                        standards: this.props.standards,
                        isCgmView: true,
                        timeInRanges: [
                            {
                                name: 'veryHigh',
                                minutes: statistics.veryHigh * 1440,
                                percent: Math.round(statistics.veryHigh * 100),
                                range: `<${conversion.toDisplay(250)}`
                            },
                            {
                                name: 'high',
                                minutes: statistics.high * 1440,
                                percent: Math.round(statistics.high * 100),
                                range: `>${conversion.toDisplay(standards.postMeal.highThreshold)}`
                            },
                            {
                                name: 'normal',
                                minutes: statistics.target * 1440,
                                percent: Math.round(statistics.target * 100),
                                range: `${conversion.toDisplay(standards.postMeal.lowThreshold)} - ${conversion.toDisplay(standards.postMeal.highThreshold)}`
                            },
                            {
                                name: 'low',
                                minutes: statistics.low * 1440,
                                percent: Math.round(statistics.low * 100),
                                range: `<${conversion.toDisplay(standards.postMeal.lowThreshold)}`
                            },
                            {
                                name: 'veryLow',
                                minutes: statistics.veryLow * 1440,
                                percent: Math.round(statistics.veryLow * 100),
                                range: `<${conversion.toDisplay(54)}`
                            }
                        ]
                    })
                })
            ]
        });
    }
}
_define_property(MixedDistributionWidget, "propTypes", {
    // Explicit props
    conversion: PropTypes.object.isRequired,
    standards: PropTypes.shape({
        maxValue: PropTypes.number.isRequired,
        preMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        postMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        })
    }),
    // Implicit props
    statistics: PropTypes.shape({
        veryHigh: PropTypes.number,
        high: PropTypes.number,
        target: PropTypes.number,
        low: PropTypes.number,
        veryLow: PropTypes.number
    }),
    isDisplayedGlucoseStatistics: PropTypes.bool,
    isDisplayedTimeInRanges: PropTypes.bool
});
const mapStateToProps = (state)=>({
        statistics: AmbulatoryGlucoseProfile.selectors.highlightedStatisticsFactory(constants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES)(state),
        isDisplayedGlucoseStatistics: AmbulatoryGlucoseProfile.selectors.isDisplayedGlucoseStatistics(state),
        isDisplayedTimeInRanges: AmbulatoryGlucoseProfile.selectors.isDisplayedTimeInRanges(state)
    });
const ConnectedMixedDistributionWidget = connect(mapStateToProps)(MixedDistributionWidget);
export default withStyles(styles)(ConnectedMixedDistributionWidget);
